import { render } from "./auth.vue?vue&type=template&id=296ecd0b&scoped=true&ts=true&lang=pug"
import script from "./auth.vue?vue&type=script&setup=true&lang=ts"
export * from "./auth.vue?vue&type=script&setup=true&lang=ts"

import "./auth.vue?vue&type=style&index=0&id=296ecd0b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296ecd0b"]])

export default __exports__